<template lang="pug">
a#back-to-top.btn.back-to-top.d-none(href="javascript:void(0);" role="button")
  i.fas.fa-arrow-up
</template>

<script>
export default {
  mounted() {
    $("#back-to-top").click(function() {
      $(".content-center").animate(
        {
          scrollTop: 0
        },
        400
      );
      return false;
      $("#toolbar").removeClass("active");
    });

    $(".content-center").scroll(function() {
      if ($(this).scrollTop() > 50) {
        $("#back-to-top").fadeIn();
      } else {
        $("#back-to-top").fadeOut();
      }
    });
  }
};
</script>